import { useMutation } from '@tanstack/react-query';
import { enableHandByHandRest, disableHandByHandRest } from '@/services/tournaments/tournaments-service';

const useHandByHandMode = (tournamentId: string, tournamentUrl: string) => {
  const { mutate: enableHandByHand, isPending: isEnablingHandByHand } = useMutation({
    mutationFn: () => enableHandByHandRest(tournamentUrl),
    mutationKey: ['enable-hand-by-hand', tournamentId],
  });

  const { mutate: disableHandByHand, isPending: isDisablingHandByHand } = useMutation({
    mutationFn: () => disableHandByHandRest(tournamentUrl),
    mutationKey: ['disable-hand-by-hand', tournamentId],
  });

  return {
    enableHandByHand,
    disableHandByHand,
    isEnablingHandByHand,
    isDisablingHandByHand,
  };
};

export default useHandByHandMode;
